import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setCurrentPage } from '../../../feature/userData/userData';
import { getSubscriptionTransactionList } from '../../../service/api/paymentGateway/getSubscriptionTransactionList';
import { getCallLogTransactionList } from '../../../service/api/paymentGateway/getCallLogTransactionList';
import SkeletonDivElement from '../../../component/skeletonTableRow/skeletonDivElement';
import emptyListImg from '../../../media/images/servicesAssets/emptyListImg.png'
import { getEarningsInformationApi } from '../../../service/api/paymentGateway/getEarningsInformation';
import { getPayoutListById } from '../../../service/api/paymentGateway/getPayoutListById';
import { getPaymentTransactionListApi } from '../../../service/api/paymentGateway/getPaymentTransactionList';
import { LuArrowUpDown } from 'react-icons/lu';
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';
import { FaSearch } from 'react-icons/fa';
import CreditHistory from '../creditHistory/creditHistory';

const TransactionsList = () => {
    const { paymentMethodID, customerID, impersonateFlag, permissionArr, role, connectedAccountId, companyId } = useSelector((state) => state.user);
    const { totalEarned } = useSelector((state) => state.finance);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const permissionArray = permissionArr[0] || []

    const [paymentHistoryLoading, setPaymentHistoryLoading] = useState(false);
    const [paymentHistoryArrPro, setPaymentHistoryArrPro] = useState([]);
    const [paymentHistoryArrCust, setPaymentHistoryArrCust] = useState([]);

    const [earningsLoading, setEarningsLoading] = useState(false);
    const [connectedAccStatus, setConnectedAccStatus] = useState(false);
    const [cardPaymentsCheck, setCardPaymentsCheck] = useState(false);
    const [transfersCheck, setTransfersCheck] = useState(false);
    const [distinationAccId, setDistinationAccId] = useState('');

    const [payoutHistroyLoading, setPayoutHistroyLoading] = useState(false);
    const [payoutHistoryArrPro, setPayoutHistoryArrPro] = useState([]);

    const [listLoading, setListLoading] = useState(false)

    const [filtreBox, setFiltreBox] = useState(false);
    const [filtreValue, SetFiltreValue] = useState(1);

    useEffect(() => {
        dispatch(setCurrentPage("Transactions"))
    }, [])

    // Horizontal Scroll for navbar functions 
    const [tabsToggle, setTabsToggle] = useState(1);
    const [isScrolling, setIsScrolling] = useState(false);
    const [startX, setStartX] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);

    const navbarRef = useRef(null);

    const onMouseDown = (e) => {
        setIsScrolling(true);
        setStartX(e.pageX - navbarRef.current.offsetLeft);
        setScrollLeft(navbarRef.current.scrollLeft);
    };

    const onMouseLeave = () => {
        setIsScrolling(false);
    };

    const onMouseUp = () => {
        setIsScrolling(false);
    };

    const onMouseMove = (e) => {
        if (!isScrolling) return;
        e.preventDefault();
        const x = e.pageX - navbarRef.current.offsetLeft;
        const walk = (x - startX) * 2; // The multiplier 2 determines the scroll speed
        navbarRef.current.scrollLeft = scrollLeft - walk;
    };

    function getSubscriptionTransactionListFn() {
        setPaymentHistoryLoading(true)
        let details = new FormData();
        details.append("status_chr", 'all');

        dispatch(
            getSubscriptionTransactionList(details, (res) => {
                setPaymentHistoryLoading(false)
                // console.log(res.data.data);
                setPaymentHistoryArrPro(res.data.data)


            }, (err) => {
                setPaymentHistoryLoading(false)
                // console.log(err);
            })
        )
    }

    const getCallLogTransactionListFn = () => {
        setPaymentHistoryLoading(true)
        let data = {
            current_date: Math.floor(Date.now() / 1000),
            filter_type: '',
        }
        dispatch(
            getCallLogTransactionList(data,
                (res) => {
                    setPaymentHistoryLoading(false)
                    // console.log(res.data.data);
                    setPaymentHistoryArrCust(res.data.data)
                },
                (res) => {
                    setPaymentHistoryLoading(false)
                    // console.log(res)
                })
        )
    }



    const convertUnixTime = (unixTime) => {
        // Create a new Date object from the Unix timestamp
        // Note: Unix timestamp should be in milliseconds for JavaScript Date object,
        // so we multiply by 1000 (because Unix timestamp is usually in seconds).
        const date = new Date(unixTime * 1000);

        // Define an array of month names to convert month number to month name
        const months = ["January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"];

        // Extract the day, month and year from the date
        const day = date.getDate();
        const month = months[date.getMonth()];
        const year = date.getFullYear();

        // Return the formatted date string
        return `${month} ${day}, ${year}`;
    }

    let USDollar = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });

    // new functions for the earnings
    const getEarningsInformationFn = () => {
        setEarningsLoading(true);
        let details = {};
        dispatch(
            getEarningsInformationApi(
                details,
                (res) => {

                    setEarningsLoading(false);


                    setConnectedAccStatus(res?.data?.data?.connected_account_info?.connected_account_status)
                    if (res?.data?.data?.connected_account_info?.connected_account_details.capabilities?.card_payments === "active") { setCardPaymentsCheck(true) }
                    if (res?.data?.data?.connected_account_info?.connected_account_details.capabilities?.transfers === "active") { setTransfersCheck(true) }

                    Object.keys(res?.data?.data?.connected_account_info?.connected_account_details?.external_accounts).length > 0 &&
                        setDistinationAccId(res?.data?.data?.connected_account_info?.connected_account_details?.external_accounts?.data[0].id)
                },
                (res) => {
                    setEarningsLoading(false);
                    // console.log(res?.data?.data);
                }
            )
        );
    };

    useEffect(() => {
        if (connectedAccountId && (permissionArray.includes("UPDATE WORK INFORMATION") || permissionArray.includes("VIEW COMPANY SERVICE REQUESTS"))) {
            getEarningsInformationFn();
        }
    }, []);

    const viewServiceDetails = (element) => {
        localStorage.setItem("ticket_id", element?.ticket_id_lng);
        navigate("/serviceRequestDetails");
    }

    const getPayoutListByIdFn = () => {
        setPayoutHistroyLoading(true);
        // let data = {
        //     connected_account_id_ids: connectedAccountId,
        //     destination_id_ids: distinationAccId,
        // }
        let data = new FormData();
        data.append("status_chr", 'all');


        dispatch(
            getPayoutListById(data,
                (res) => {
                    setPayoutHistroyLoading(false);
                    // console.log(res.data.data.data, 'ajkshdagduyd');
                    setPayoutHistoryArrPro(res.data.data.data)
                },
                (res) => {
                    setPayoutHistroyLoading(false);
                    // console.log(res)
                })
        )
    }


    // New functions for the sorting and pagination 
    const [page, setPage] = React.useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalPage, setTotalPage] = useState(1);
    const [sortByValue, setSortByValue] = useState("DESC");
    const [searchValue, setSearchValue] = useState("");
    const [bulkDeleteArr, setBulkDeleteArr] = useState([]);
    const [skeltonVal, setSkeltonVal] = useState(false);
    const [columnName, setColumnName] = useState("");
    const [totalNoRecord, setTotalNoRecord] = useState(100);
    const [flag, setFlag] = useState(false);

    // const [elements, setElements] = useState([]);

    const handlePaymentTransactionLists = (res) => {

        // console.log(res.data.data, 'res array')
        // console.log(res.data.total_count, 'total count')

        if (tabsToggle == 1) {
            const newElements = [...paymentHistoryArrCust, ...res.data.data];
            const uniqueElements = Array.from(
                new Set(newElements.map(JSON.stringify))
            ).map(JSON.parse);
            setPaymentHistoryArrCust(uniqueElements);
            setTotalNoRecord(res.data.total_count);
            if (res.total_count % pageSize === 0) {
                setTotalPage(parseInt(res.total_count / pageSize));
            } else {
                setTotalPage(parseInt(res.total_count / pageSize + 1));
            }
        }

        else if (tabsToggle == 2) {
            // const newElements = [...transactionList, ...res.data.data];
            // const uniqueElements = Array.from(
            //     new Set(newElements.map(JSON.stringify))
            // ).map(JSON.parse);
            // setTransactionList(uniqueElements);
            // setTotalNoRecord(res.data.total_count);
            // if (res.total_count % pageSize === 0) {
            //     setTotalPage(parseInt(res.total_count / pageSize));
            // } else {
            //     setTotalPage(parseInt(res.total_count / pageSize + 1));
            // }
        }
    }

    const getPaymentTractionListFn = () => {

        let data = new FormData();
        data.append("status_chr", 'all')
        data.append("current_date", Math.floor(Date.now() / 1000))
        data.append("filter_type", '')
        data.append("page_index", page)
        data.append("page_size", pageSize)
        data.append("sorting_order", sortByValue)
        data.append("sorting_column_name", columnName)
        data.append("search_area", searchValue)

        setListLoading(true);
        dispatch(
            getPaymentTransactionListApi(
                data,
                (res) => {
                    // console.log(res.data.data, "getPaymentTractionListFn")
                    handlePaymentTransactionLists(res);
                    setListLoading(false);
                },
                (res) => {
                    // console.log(res.data.data);
                    setListLoading(false);
                }
            )
        );
    };

    const getPaymentTractionListSearch = () => {
        let data = new FormData();
        data.append("status_chr", 'all')
        data.append("page_index", page)
        data.append("page_size", pageSize)
        data.append("sorting_order", sortByValue)
        data.append("sorting_column_name", columnName)
        data.append("search_area", searchValue)

        setListLoading(true);
        dispatch(
            getPaymentTransactionListApi(
                data,
                (res) => {
                    // console.log(res.data.data, "getPaymentTractionListFn search")
                    handlePaymentTransactionLists(res);
                    setListLoading(false);
                },
                (res) => {
                    // console.log(res.data.data);
                    setListLoading(false);
                }
            )
        );
    };

    useEffect(() => {
        if (searchValue.trim().length > 2) {
            setFlag(true);
            const timeOutId = setTimeout(getPaymentTractionListSearch, 1000);
            return () => clearTimeout(timeOutId);
        } else if (searchValue.trim().length === 0) {
            if (flag) {
                getPaymentTractionListSearch();
            }
        }
    }, [searchValue]);


    // useEffect(() => {
    //     getPaymentTractionListFn();
    // }, [page, pageSize, sortByValue, columnName, tabsToggle, filtreValue]);


    function handleOpenFiltreBox() {
        setFiltreBox(!filtreBox);
    }

    function handleSetFiltreValue(v) {
        SetFiltreValue(v);
        const ele = [];
        setPage(1);
        setPaymentHistoryArrCust(ele);
        // setTransactionList(ele);
        if (v === 1) {
            setSortByValue("DESC");
        } else if (v === 2) {
            setSortByValue("ASC");
        }
    }

    const handleSearch = (e) => {
        // setPage(1)
        // handleToggle(null);
        if (searchValue.trim().length >= 2) {
            onChangePage(1);
            setColumnName("");
        }
        setSearchValue(e.target.value);
    };

    const onChangePage = (e, p) => {
        // setPage(p)
        // handleToggle(null);
        setPage(e);
    };

    useEffect(() => {
        setPage(1);
        setPaymentHistoryArrCust([]);
        // setPaymentListArr([]);
        // setTransactionList([]);
        // onLoadData();
    }, [tabsToggle, searchValue]);


    useEffect(() => {
        if (tabsToggle === 1) {
            if (permissionArray.includes("UPDATE WORK INFORMATION") || permissionArray.includes("VIEW COMPANY SERVICE REQUESTS")) {
                getSubscriptionTransactionListFn();
            }
            if (permissionArray.includes("SCAN TAB")) {
                // getCallLogTransactionListFn();
                getPaymentTractionListFn();
            }
        }
    }, [page, pageSize, sortByValue, columnName, tabsToggle, filtreValue])

    return (
        <>
            <div className='row mx-0 p-3'>
                <div className='col-12 px-0'>
                    <div className='row mx-0'>
                        <div className='col-12 px-0'>
                            {/* Navigations earnings */}
                            <div
                                className='border-bottom mt-3 overflow-auto row text-nowrap user-profile-nav-bar whitespace-nowrap'
                                ref={navbarRef}
                                onMouseDown={onMouseDown}
                                onMouseLeave={onMouseLeave}
                                onMouseUp={onMouseUp}
                                onMouseMove={onMouseMove}
                            >
                                <div className='col-12 d-flex px-0 fs-5 font-w500'>
                                    <div
                                        onClick={() => setTabsToggle(1)}
                                        className={`cursor-pointer overlay-action-btn align-items-cente d-flex justify-content-center px-4 py-3 position-relative`}
                                        style={{}}
                                    >
                                        <span className={`${tabsToggle === 1 ? "text-black" : "text-grey"} ${tabsToggle === 1 && "fw-bold"}`} >{"Payment history"}</span>
                                        {tabsToggle === 1 && <div className='position-absolute w-100 bg-black bottom-0' style={{ height: "3px" }}> </div>}
                                    </div>


                                    {((permissionArray.includes("UPDATE WORK INFORMATION") && !companyId) || (permissionArray.includes("UPDATE WORK INFORMATION") && companyId && totalEarned > 0) || (permissionArray.includes("VIEW COMPANY SERVICE REQUESTS"))) &&
                                        <div
                                            onClick={() => {
                                                setTabsToggle(2);
                                                if (connectedAccountId && connectedAccStatus && cardPaymentsCheck && transfersCheck) {
                                                    getPayoutListByIdFn();
                                                }
                                            }}
                                            className='cursor-pointer overlay-action-btn align-items-cente d-flex justify-content-center px-4 py-3 position-relative'
                                            style={{
                                                // pointerEvents: connectedAccountId && connectedAccStatus && cardPaymentsCheck && transfersCheck ? 'auto' : 'none',
                                                // opacity: connectedAccountId && connectedAccStatus && cardPaymentsCheck && transfersCheck ? 1 : 0.5,
                                            }}
                                        >
                                            <span className={`${tabsToggle === 2 ? "text-black" : "text-grey"} ${tabsToggle === 2 && "fw-bold"}`}>{"Payout history"}</span>
                                            {tabsToggle === 2 && <div className='position-absolute w-100 bg-black bottom-0' style={{ height: "3px", }}> </div>}
                                        </div>
                                    }

                                    <div
                                        onClick={() => setTabsToggle(3)}
                                        className={`cursor-pointer overlay-action-btn align-items-cente d-flex justify-content-center px-4 py-3 position-relative`}
                                        style={{}}
                                    >
                                        <span className={`${tabsToggle === 3 ? "text-black" : "text-grey"} ${tabsToggle === 3 && "fw-bold"}`} >{"Credit history"}</span>
                                        {tabsToggle === 3 && <div className='position-absolute w-100 bg-black bottom-0' style={{ height: "3px" }}> </div>}
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    {/* searching and sorting */}

                    {tabsToggle === 1 && permissionArray.includes("SCAN TAB") &&
                        <div
                            className="row border-bottom px-2 my-1"
                            style={{
                                // backgroundColor: "rgba(251, 252, 255, 1)",
                                // borderRadius: '16px',
                            }}
                        >
                            <div
                                className="row mx-0 my-3 align-items-center "
                                style={{ minHeight: "40px" }}
                            >

                                <div className="col-12">
                                    <div className="row">
                                        <span className="fs-6 p-2 d-flex align-items-center justify-content-end">

                                            <span className="fs-5 p-2 d-flex align-items-center">
                                                <LuArrowUpDown
                                                    className="pointer"
                                                    style={{ marginRight: "4px", color: "black" }}
                                                    onClick={handleOpenFiltreBox}
                                                />
                                                <span
                                                    className="fs-6  pointer"
                                                    style={{ position: "relative" }}
                                                    onClick={handleOpenFiltreBox}>
                                                    {filtreValue == 1 && "Date: Newest first"}
                                                    {filtreValue == 2 && "Date: Oldest first"}
                                                    {/* {filtreValue == 3 && " Price: Highest first"}
                      {filtreValue == 4 && "Price: Lowest first"}{" "} */}
                                                    &nbsp;
                                                    {filtreBox ? <IoIosArrowUp /> : <IoIosArrowDown />}
                                                    <span
                                                        className={`${filtreBox ? "" : "d-none"} p-3`}
                                                        style={{
                                                            position: "absolute",
                                                            top: "26px",
                                                            width: "170px",
                                                            zIndex: 1,
                                                            border: "1px solid lightgray",
                                                            background: "white",
                                                            right: "0",
                                                            boxShadow: "0px 4px 12px 0px rgba(0, 0, 0, 0.12)",
                                                        }}>
                                                        <div className="row">
                                                            <div
                                                                className={`${filtreValue == 1 ? "dt" : ""
                                                                    } d-flex justify-content-start m-1 pointer `}
                                                                onClick={() => {
                                                                    handleSetFiltreValue(1);
                                                                }}>
                                                                <div className="d-flex align-items-center" style={{ width: '20px' }}>
                                                                    {filtreValue == 1 && <i className="bi bi-check-lg"></i>}
                                                                </div>
                                                                Date: Newest first
                                                            </div>
                                                            <div
                                                                className={`${filtreValue == 2 ? "dt" : ""
                                                                    } d-flex justify-content-start m-1 pointer`}
                                                                onClick={() => {
                                                                    handleSetFiltreValue(2);
                                                                }}>
                                                                <div className="d-flex align-items-center" style={{ width: '20px' }}>
                                                                    {filtreValue == 2 && <i className="bi bi-check-lg"></i>}
                                                                </div>
                                                                Date: Oldest first
                                                            </div>
                                                            {/* <div
                            className={`${
                              filtreValue == 3 ? "dt" : ""
                            } d-flex justify-content-start m-1 pointer`}
                            onClick={() => {
                              handleSetFiltreValue(3);
                            }}>
                            Price: Highest first
                          </div>
                          <div
                            className={`${
                              filtreValue == 4 ? "dt" : ""
                            } d-flex justify-content-start m-1 pointer`}
                            onClick={() => {
                              handleSetFiltreValue(4);
                            }}>
                            Price: Lowest first
                          </div> */}
                                                        </div>
                                                    </span>
                                                </span>
                                            </span>

                                            <span
                                                className="fs-6 p-2 d-flex align-items-center"
                                                style={{
                                                    border: "1px solid lightgray",
                                                    borderRadius: "6px",
                                                }}>
                                                <FaSearch style={{ marginRight: "4px", color: "black" }} />
                                                <input
                                                    placeholder="Search"
                                                    style={{ border: "0px", width: "100%" }}
                                                    onChange={handleSearch}
                                                    value={searchValue}
                                                />
                                            </span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }



                    {tabsToggle === 1 &&
                        <div className='row mx-0 py-2'>
                            <div className='col-12 px-0'>

                                <>

                                    {/* View payment history for pro */}
                                    {(permissionArray.includes("UPDATE WORK INFORMATION") || permissionArray.includes("VIEW COMPANY SERVICE REQUESTS")) &&
                                        <div className='h-100 overflow-auto' style={{}}>

                                            {paymentHistoryLoading ?
                                                <>
                                                    {[1, 2, 3, 4, 5, 6, 7].map((element, index) => {
                                                        return (
                                                            <SkeletonDivElement key={index} height={'60px'} marginBottom={'5px'} borderRadius={'0px'} />
                                                        )
                                                    })}
                                                </> : <>
                                                    {paymentHistoryArrPro.length > 0 ?
                                                        <>
                                                            {
                                                                paymentHistoryArrPro.map((element, index) => {
                                                                    return (
                                                                        <>
                                                                            <div key={index} className='row mx-0 border-bottom py-3'>
                                                                                <div className='col-12 px-0'>


                                                                                    <div className='row mx-2 p-3 bg-light'>

                                                                                        <div className='row align-items-center mb-1'>
                                                                                            <div className='col-12 px-0 d-flex justify-content-between align-items-center'>
                                                                                                <div className=''>
                                                                                                    {/* <span className='font-w500'>{`${convertUnixTime(element?.created_date_dtm)}`}</span> */}

                                                                                                    <span className="font-w500">{`${element?.created_date_dtm ?
                                                                                                        new Intl.DateTimeFormat("en-US", {
                                                                                                            year: "numeric",
                                                                                                            month: "short",
                                                                                                            day: "numeric",
                                                                                                            hour: 'numeric',
                                                                                                            minute: 'numeric',
                                                                                                            hour12: true
                                                                                                        }).format(
                                                                                                            element?.created_date_dtm * 1000
                                                                                                        ) : '-'}`}</span>
                                                                                                </div>

                                                                                                <div className=''>
                                                                                                    {/* <span className='font-w500 text-black'>{`${USDollar.format(element?.subscription_invoice_meta_data?.amount_paid / 100)}`}</span> */}
                                                                                                    <span className='font-w600 text-black'>{`${USDollar.format(element?.subscription_invoice_meta_data?.amount_paid / 100)}`}</span>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>

                                                                                        {element?.payment_method_meta_data?.card?.brand &&
                                                                                            <div className='col-12 px-0 mb-1'>
                                                                                                <span>{`Payment method: `}</span>
                                                                                                <span className='font-w600 text-black'>{`${element?.payment_method_meta_data?.card?.brand?.toUpperCase()} - *${element?.payment_method_meta_data?.card?.last4}`}</span>
                                                                                            </div>
                                                                                        }

                                                                                        {element?.subscription_invoice_meta_data?.description_chr &&
                                                                                            <div className='col-12 px-0 mb-1'>
                                                                                                <span className='font-w500 text-black'>{`${(element?.subscription_invoice_meta_data?.description_chr)}`}</span>
                                                                                            </div>
                                                                                        }

                                                                                        <div className='col-12 px-0'>
                                                                                            <span>{`Time period: `}</span>
                                                                                            <span>{`${convertUnixTime(element?.subscription_invoice_meta_data?.lines?.data[0]?.period?.start)} - `}</span>
                                                                                            <span>{`${convertUnixTime(element?.subscription_invoice_meta_data?.lines?.data[0]?.period?.end)}`}</span>
                                                                                        </div>

                                                                                        <div className='col-12 px-0'>
                                                                                            <span>{`Payment status: `}</span>
                                                                                            <span
                                                                                                className={`font-w600 ${element?.subscription_invoice_meta_data?.status === "paid" ? "text-success" : "text-black"} `}
                                                                                            >
                                                                                                {`${element?.subscription_invoice_meta_data?.status}`}
                                                                                            </span>
                                                                                        </div>

                                                                                        <div className='col-12 px-0'>
                                                                                            <span className='font-w600 text-decoration-underline'>
                                                                                                <a href={element?.subscription_invoice_meta_data?.hosted_invoice_url} target="_blank" rel="noreferrer">
                                                                                                    {`Invoice link`}
                                                                                                </a>
                                                                                            </span>
                                                                                        </div>

                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                    )
                                                                })
                                                            }

                                                        </>
                                                        :
                                                        <div className='row mx-2 fs-6 py-2 mt-3'>
                                                            <div className='col-12 px-0 d-flex justify-content-center align-items-center flex-column'>
                                                                <img src={emptyListImg} style={{ width: "70px" }} alt="" />
                                                                <span className='mt-3 fs-7'>{"No payment history"}</span>
                                                            </div>
                                                        </div>
                                                    }
                                                </>}
                                        </div>
                                    }

                                    {/* View payment history for customer */}
                                    {permissionArray.includes("SCAN TAB") &&
                                        <>
                                            <>
                                                <div className='overflow-auto py-2 ' style={{}}>
                                                    {paymentHistoryArrCust?.length > 0 ?
                                                        <>
                                                            {
                                                                paymentHistoryArrCust.map((element, index) => {
                                                                    return (
                                                                        <>
                                                                            <div key={index} className='row mx-0 border-bottom py-3'>
                                                                                <div className='col-12 px-0'>
                                                                                    <div className='row mx-2 mb-1'>
                                                                                        <div className='col-12 px-0 d-flex justify-content-between align-items-center'>
                                                                                            <div className='font-w500 text-black'>
                                                                                                {/* <span>{`A ${(element?.call_duration_in_second / 60).toFixed(2)} minute video call costs ${USDollar.format(element?.payment_intent_meta_data?.amount_received / 100)}.`}</span> */}
                                                                                                <span>{`${element?.meta_data?.description ? element?.meta_data?.description : "-"}`}</span>
                                                                                            </div>

                                                                                            <div className='font-w600 text-black'>
                                                                                                {/* <span>{`${USDollar.format(Object.keys(element?.payment_to_pro_meta_data).length > 0 ? (element?.payment_to_pro_meta_data?.amount / 100) : 0)}`}</span> */}
                                                                                                <span>{`${USDollar.format(element?.meta_data?.amount ? (element?.meta_data?.amount / 100) : 0)}`}</span>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>

                                                                                    <div className='row mx-2'>
                                                                                        <div className='col-12 px-0 mb-1 d-flex justify-content-between align-items-center'>
                                                                                            <div>
                                                                                                {/* <span>{`${convertUnixTime(element?.created_date_dtm)}`}</span> */}

                                                                                                <span className="">{`${element?.created_date_dtm ?
                                                                                                    new Intl.DateTimeFormat("en-US", {
                                                                                                        year: "numeric",
                                                                                                        month: "short",
                                                                                                        day: "numeric",
                                                                                                        hour: 'numeric',
                                                                                                        minute: 'numeric',
                                                                                                        hour12: true
                                                                                                    }).format(
                                                                                                        element?.created_date_dtm * 1000
                                                                                                    ) : '-'}`}</span>
                                                                                            </div>

                                                                                            <div>
                                                                                                {/* <span>{`Platform fee `}</span>
                                                                                             <span className='font-w600 text-black'>{`${USDollar.format(Object.keys(element?.platform_fee_meta_data).length > 0 ? (element?.platform_fee_meta_data?.amount / 100) : 0)}`}</span> */}
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>

                                                                                    {element?.ticket_id_lng &&
                                                                                        <div className='row mx-2 '>
                                                                                            <div className='col-12 px-0 d-flex justify-content-start'>
                                                                                                <span
                                                                                                    className='font-w600  text-hovered cursor-pointer'
                                                                                                    onClick={() => { viewServiceDetails(element) }}
                                                                                                    style={{
                                                                                                        color: 'rgba(131, 154, 192, 1)'
                                                                                                    }}
                                                                                                >
                                                                                                    {`See service details`}
                                                                                                    <i className='bi bi-chevron-right ps-2'></i>
                                                                                                </span>
                                                                                            </div>
                                                                                        </div>
                                                                                    }
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                    )
                                                                })
                                                            }

                                                            {listLoading
                                                                ? paymentHistoryArrCust?.length > 0 &&
                                                                totalNoRecord > paymentHistoryArrCust?.length && (
                                                                    <div className="text-center pointer my-2">Loading ...</div>
                                                                )
                                                                : paymentHistoryArrCust?.length > 0 &&
                                                                totalNoRecord > paymentHistoryArrCust?.length && (
                                                                    <div
                                                                        className="text-center pointer my-3"
                                                                        onClick={() => {
                                                                            setPage(page + 1);
                                                                        }}>
                                                                        click to view more
                                                                    </div>
                                                                )}

                                                        </>
                                                        :
                                                        <>
                                                            {!listLoading && <div className='row mx-2 fs-6 py-2 mt-3'>
                                                                <div className='col-12 px-0 d-flex justify-content-center align-items-center flex-column'>
                                                                    <img src={emptyListImg} style={{ width: "70px" }} alt="" />
                                                                    <span className='mt-3 fs-7'>{"No payment history"}</span>
                                                                </div>
                                                            </div>}
                                                        </>
                                                    }
                                                    {listLoading &&
                                                        <SkeletonDivElement
                                                            height={"80px"}
                                                            rows={10}
                                                            marginBottom={'5px'}
                                                            borderRadius={'0px'}
                                                        />
                                                    }
                                                </div>
                                            </>

                                            {/* <div className='h-100 overflow-auto' style={{}}>
                                                <>
                                                    {[1, 2, 3, 4, 5, 6, 7].map((element, index) => {
                                                        return (
                                                            <SkeletonDivElement key={index} height={'60px'} marginBottom={'5px'} borderRadius={'0px'} />
                                                        )
                                                    })}
                                                </> :
                                                <>
                                                    {paymentHistoryArrCust.length > 0 ?
                                                        <>
                                                            {
                                                                paymentHistoryArrCust.map((element, index) => {
                                                                    return (
                                                                        <>
                                                                            <div key={index} className='row mx-0 border-bottom py-3'>
                                                                                <div className='col-12 px-0'>
                                                                                    <div className='row mx-2 mb-1'>
                                                                                        <div className='col-12 px-0 d-flex justify-content-between align-items-center'>
                                                                                            <div className='font-w500 text-black'>
                                                                                                <span>{`${element?.payment_intent_meta_data?.description}`}</span>
                                                                                            </div>

                                                                                            <div className='font-w600 text-black'>
                                                                                                <span>{`${USDollar.format(element?.payment_intent_meta_data?.amount_received ? (element?.payment_intent_meta_data?.amount_received / 100) : 0)}`}</span>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>

                                                                                    <div className='row mx-2'>
                                                                                        <div className='col-12 px-0 mb-1 d-flex justify-content-between align-items-center'>
                                                                                            <div>
                                                                                                <span>{`${convertUnixTime(element?.created_date_dtm)}`}</span>
                                                                                            </div>

                                                                                            <div>

                                                                                            </div>
                                                                                        </div>
                                                                                    </div>

                                                                                    {element?.ticket_id_lng &&
                                                                                        <div className='row mx-2 '>
                                                                                            <div className='col-12 px-0 d-flex justify-content-start'>
                                                                                                <span
                                                                                                    className='font-w600  text-hovered cursor-pointer'
                                                                                                    onClick={() => { viewServiceDetails(element) }}
                                                                                                    style={{
                                                                                                        color: 'rgba(131, 154, 192, 1)'
                                                                                                    }}
                                                                                                >
                                                                                                    {`See service details`}
                                                                                                    <i className='bi bi-chevron-right ps-2'></i>
                                                                                                </span>
                                                                                            </div>
                                                                                        </div>
                                                                                    }
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                    )
                                                                })
                                                            }

                                                        </>
                                                        :
                                                        <div className='row mx-2 fs-6 py-2 mt-3'>
                                                            <div className='col-12 px-0 d-flex justify-content-center align-items-center flex-column'>
                                                                <img src={emptyListImg} style={{ width: "70px" }} alt="" />
                                                                <span className='mt-3 fs-7'>{"No payment history"}</span>
                                                            </div>
                                                        </div>
                                                    }
                                                </>

                                            </div> */}
                                        </>
                                    }

                                    {/* If not have any of above permission */}
                                    {/* {!permissionArray.includes("SCAN TAB") && !permissionArray.includes("UPDATE WORK INFORMATION") &&
                                        <div className='row mx-2 fs-6 py-2 mt-3'>
                                            <div className='col-12 px-0 d-flex justify-content-center align-items-center flex-column'>
                                                <img src={emptyListImg} style={{ width: "70px" }} alt="" />
                                                <span className='mt-3 fs-7'>{"No payment history"}</span>
                                            </div>
                                        </div>
                                    } */}
                                </>
                            </div>
                        </div>
                    }

                    {tabsToggle === 2 &&
                        <div className='row mx-0 py-2'>
                            <div className='col-12 px-0'>
                                {payoutHistroyLoading ?
                                    <>
                                        {[1, 2, 3, 4, 5, 6, 7].map((element, index) => {
                                            return (
                                                <SkeletonDivElement key={index} height={'60px'} marginBottom={'5px'} borderRadius={'0px'} />
                                            )
                                        })}
                                    </> :
                                    <>
                                        {payoutHistoryArrPro?.length > 0 ?
                                            <>
                                                {
                                                    payoutHistoryArrPro?.map((element, index) => {
                                                        return (
                                                            <>
                                                                <div key={index} className='row mx-0 border-bottom py-3'>
                                                                    <div className='col-12 px-0'>
                                                                        <div className='row mx-2 mb-1'>
                                                                            <div className='col-12 px-0 d-flex justify-content-between align-items-center'>
                                                                                <div className='font-w500 text-black'>
                                                                                    <span>{`Withdrawal to your bank account.`}</span>
                                                                                </div>

                                                                                <div className='font-w600 text-black'>
                                                                                    <span>{`${USDollar.format(element?.amount / 100)}`}</span>
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                        <div className='row mx-2'>
                                                                            <div className='col-12 px-0 mb-1 d-flex justify-content-between align-items-center'>
                                                                                <div>
                                                                                    <span>{`${convertUnixTime(element?.created)}`}</span>
                                                                                </div>

                                                                                <div>
                                                                                    {/* <span>{`Service fee `}</span>
                                                                                            <span className='font-w600 text-black'>{`$0.00`}</span> */}
                                                                                    {
                                                                                        <span
                                                                                            title={`${element?.status === 'failed' ? element?.failure_message : ''}`}
                                                                                            className={`${element?.status === 'failed' ? 'text-danger' : element?.status === 'paid' ? 'text-success' : 'text-primary'}`}
                                                                                        >
                                                                                            {element?.status}
                                                                                        </span>
                                                                                    }
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        )
                                                    })
                                                }

                                            </>
                                            :
                                            <div className='row mx-0 h-100'>
                                                <div className='row mx-2 fs-6 py-2 mt-3'>
                                                    <div className='col-12 px-0 d-flex justify-content-center align-items-center flex-column'>
                                                        <img src={emptyListImg} style={{ width: "70px" }} alt="" />
                                                        <span className='mt-3 fs-7'>{"No payout history"}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </>}
                            </div>
                        </div>
                    }

                    {tabsToggle === 3 &&
                        <CreditHistory />
                    }


                </div>
            </div>
        </>
    )
}

export default TransactionsList